export default __webpack_public_path__ + "static/media/education2.87ba79c5.jpg";